import Globalize from 'globalize';

const currencyShortFormatter = (currency) => Globalize.currencyFormatter(currency, {
  compact: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

const currencyMediumFormatter = (currency) => Globalize.currencyFormatter(currency, {
  compact: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const currencyRoundFormatter = (currency) => Globalize.currencyFormatter(currency, {
  round: 'round',
  maximumFractionDigits: 0,
});

const currencyLongFormatter = (currency) => Globalize.currencyFormatter(currency);

const numberShortFormatter = (locale) => Globalize(locale).numberFormatter({
  compact: 'short',
  minimumSignificantDigits: 3,
  maximumSignificantDigits: 3,
});

const numberShortRoundFormatter = (locale) => Globalize(locale).numberFormatter({
  compact: 'short',
  minimumSignificantDigits: 1,
  maximumSignificantDigits: 3,
});

const numberLongFormatter = (locale) => Globalize(locale).numberFormatter({
  minimumSignificantDigits: 1,
  maximumSignificantDigits: 3,
});

export {currencyShortFormatter, currencyMediumFormatter, currencyLongFormatter, currencyRoundFormatter, numberShortFormatter, numberShortRoundFormatter, numberLongFormatter};
